/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_ReflectionInputs */

const en_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const de_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const fr_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const es_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const it_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const nl_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const pl_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const fi_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const da_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

const sv_story_bank_label_reflection = /** @type {(inputs: Story_Bank_Label_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection (optional)`)
};

/**
* | output |
* | --- |
* | "Reflection (optional)" |
*
* @param {Story_Bank_Label_ReflectionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_reflection = /** @type {((inputs?: Story_Bank_Label_ReflectionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_ReflectionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_reflection(inputs)
	if (locale === "fr") return fr_story_bank_label_reflection(inputs)
	if (locale === "es") return es_story_bank_label_reflection(inputs)
	if (locale === "it") return it_story_bank_label_reflection(inputs)
	if (locale === "nl") return nl_story_bank_label_reflection(inputs)
	if (locale === "pl") return pl_story_bank_label_reflection(inputs)
	if (locale === "fi") return fi_story_bank_label_reflection(inputs)
	if (locale === "da") return da_story_bank_label_reflection(inputs)
	if (locale === "sv") return sv_story_bank_label_reflection(inputs)
	return en_story_bank_label_reflection(inputs)
});